import { useContext } from "react";

import { AuthenticationStoreContext } from "../AuthenticationStore.context";

export function useAuthenticationStore() {
    const store = useContext(AuthenticationStoreContext);

    if (!store) {
        throw Error("AuthenticationStoreContext not available.");
    }

    return store;
}
